import {z} from '@hono/zod-openapi';

/** `attachmentsFailed > 0` still means the ticket exists — attachments are uploaded after it. */
export const createIssueReportResponseSchema = z
  .object({
    ticketKey: z.string().min(1),
    ticketUrl: z.string().url().optional(),
    attachmentsTotal: z.number().int().nonnegative().default(0),
    attachmentsFailed: z.number().int().nonnegative().default(0),
  })
  .openapi('CreateIssueReportResponse');

export type CreateIssueReportResponse = z.infer<typeof createIssueReportResponseSchema>;
